import { FINCARAIZ_BLOG_DEFAULT_URL } from "./FincaraizNewsSection.config";

type HeaderLink = {
	title: string;
	link: string;
};

export const getNoticiasBlogLink = (header_links?: HeaderLink[]) =>
	header_links?.find(({ title }) => /noticias/i.test(title))?.link || FINCARAIZ_BLOG_DEFAULT_URL;

export const buildBlogPostLink = (
	blogBase: string | undefined,
	slug: string,
	postLink?: string
): string => {
	if (postLink?.trim()) return postLink.trim();

	const resolvedBase = blogBase || FINCARAIZ_BLOG_DEFAULT_URL;
	const base = resolvedBase.endsWith("/") ? resolvedBase : `${resolvedBase}/`;
	return `${base}${slug}/`;
};
